import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryButtons from './components/CategoryButtons';
import WhatIs from './components/WhatIs';
import ComparisonTable from './components/ComparisonTable';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import SafetySection from './components/SafetySection';
import ArticleSection from './components/ArticleSection';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      "name": "Vigorbuy Spreadsheet Resource",
      "url": SITE_URL,
      "description": "An independent educational and product discovery platform for Vigorbuy Spreadsheet. We help shoppers find better products through curated resources, QC photo guides, and expert shopping tips.",
      "logo": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg"
      },
      "sameAs": []
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      "name": "Vigorbuy Spreadsheet Resource",
      "url": SITE_URL,
      "description": "Discover the ultimate Vigorbuy Spreadsheet resource platform. Explore curated product categories, verified QC guides, shopping tips, and expert insights.",
      "publisher": {
        "@id": `${SITE_URL}/#organization`
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${SITE_URL}/?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "WebPage",
      "@id": `${SITE_URL}/#webpage`,
      "url": SITE_URL,
      "name": "Vigorbuy Spreadsheet — The Ultimate Product Finding Resource",
      "description": "Discover the latest Vigorbuy Spreadsheet collections, verified product finds, QC photos, shopping guides, and expert tips. Updated regularly with the latest Vigorbuy Spreadsheet curated product resources for 2026.",
      "isPartOf": {
        "@id": `${SITE_URL}/#website`
      },
      "about": {
        "@id": `${SITE_URL}/#organization`
      },
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "url": "https://readdy.ai/api/search-image?query=A%20warm%20minimal%20abstract%20composition%20with%20soft%20cream%20beige%20and%20gentle%20terracotta%20gradients%2C%20flowing%20organic%20shapes%20reminiscent%20of%20fabric%20folds%2C%20subtle%20texture%2C%20light%20airy%20atmosphere%2C%20modern%20aesthetic%2C%20editorial%20quality&width=1200&height=630&seq=homepage-og&orientation=landscape"
      }
    }
  ]
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <Hero />
      <CategoryDropdown />
      <CategoryButtons />
      <WhatIs />
      <ComparisonTable />
      <Features />
      <HowItWorks />
      <SafetySection />

      {/* CTA Banner */}
      <section className="py-14 md:py-16 bg-accent-500">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-background-50 mb-3">
            Ready to Explore Better Products?
          </h2>
          <p className="text-sm md:text-base text-background-50/90 mb-7 max-w-lg mx-auto">
            Discover the latest Vigorbuy Spreadsheet collections and find your next favorite product. Browse curated categories, compare options, and shop with confidence.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-background-50 text-accent-600 px-8 py-3.5 rounded-md text-base font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Access Main Website
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </section>

      <ArticleSection />
      <Footer />
    </main>
  );
}